// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"555":"10a3e3de","923":"e5b8bff3"}[chunkId] + ".chunk.css";
};